<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
  <Header ref="header" />
  <div :class="{'main-content-offset': isStickyRoute}">
    <router-view />
  </div>
  <Footer v-if="showFooter" />
  <RamadanPopup ref="ramadanPopup" @donate="handleDonate" @bank-transfer="openBankDetails" />
  <BankDetailsPopup ref="bankDetailsPopup" />
  <Toast />
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import RamadanPopup from "@/components/RamadanPopup.vue";
import BankDetailsPopup from "@/components/BankDetailsPopup.vue";
import Toast from "@/components/Toast.vue";

export default {
  components: {
    Header,
    Footer,
    RamadanPopup,
    BankDetailsPopup,
    Toast,
  },
  computed: {
    showFooter() {
      const hiddenPaths = ['/dashboard', '/update-profile', '/change-password'];
      // window.location.pathname is always correct from the URL on hard refresh (not reactive)
      // $route.path is reactive for SPA navigation clicks
      // Check BOTH so neither case is missed
      const windowPath = window.location.pathname;
      const routePath = this.$route?.path || '';
      return !hiddenPaths.some(p => windowPath.startsWith(p)) &&
             !hiddenPaths.some(p => routePath.startsWith(p));
    },
    isStickyRoute() {
      const stickyPaths = ['/dashboard', '/update-profile', '/change-password'];
      const path = this.$route?.path || '';
      return stickyPaths.some(p => path.startsWith(p));
    }
  },
  mounted() {
    // Token is now managed by store and localStorage
  },
  methods: {
    handleDonate() {
      // Trigger the donation popup from Header component (bank details)
      if (this.$refs.header) {
        this.$refs.header.toggleDonate('open');
      }
    },
    openRamadanPopup() {
      // Open the Ramadan popup
      if (this.$refs.ramadanPopup) {
        this.$refs.ramadanPopup.openPopup();
      }
    },
    openBankDetails() {
      // Open the bank details popup
      if (this.$refs.bankDetailsPopup) {
        this.$refs.bankDetailsPopup.openPopup();
      }
    },
  },
};
</script>
<style>
html, body {
  overflow-x: hidden;
  width: 100%;
  max-width: 100vw;
}

#app {
  overflow-x: hidden;
  width: 100%;
}

.main-content-offset {
  padding-top: 80px; /* Approximate header height */
}

@media screen and (max-width: 991px) {
  .main-content-offset {
    padding-top: 70px;
  }
}
</style>
